import type {
    ApiPackaging,
    ApiPackagingLineItem,
    ApiPackagingLineItemContent,
} from './transportExecution.packaging.schema';
import type {
    Packaging,
    PackagingLineItem,
    PackagingLineItemContent,
} from '../../domain/model/packaging/Packaging.types';

const toPackagingLineItemContent = (src: ApiPackagingLineItemContent): PackagingLineItemContent => ({
    code: src.code,
    description: src.description ?? undefined,
    quantity: src.quantity,
});

const toPackagingLineItem = (src: ApiPackagingLineItem): PackagingLineItem => ({
    id: src.id,
    code: src.code,
    description: src.description ?? undefined,
    quantity: src.quantity,
    weightKg: src.weight_kg,
    volumeM3: src.volume_m3,
    packagingComponentIds: src.packaging_component_ids,
    content: src.content.map(toPackagingLineItemContent),
});

export const toPackaging = (src: ApiPackaging): Packaging => ({
    shipmentId: src.shipment_id,
    packagingId: src.packaging_id,
    totalLineItems: src.total_line_items,
    totalWeightKg: src.total_weight_kg,
    totalVolumeM3: src.total_volume_m3,
    lineItems: src.line_items.map(toPackagingLineItem),
});
